/**
 * The record every First 100 Days screen reads: the person's mandate (the
 * transition, its stakeholders and decisions) from Mandate's store, and the
 * workspace's items, loaded once per screen. The journey keeps nothing of its own.
 */

import { useEffect, useState } from 'react';
import { useMandateStore } from '@/stores/mandate/mandateStore';
import { useItemsStore } from '@/stores/prioritization/itemsStore';
import { getDayNumber } from '@/types/mandate';
import { phaseForDay } from './first100Days';

export function useJourney() {
  const transition = useMandateStore((s) => s.transition);
  const stakeholders = useMandateStore((s) => s.stakeholders);
  const decisions = useMandateStore((s) => s.decisions);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void Promise.all([useMandateStore.getState().fetchAll(), useItemsStore.getState().fetchFromSupabase()]).then(() => {
      if (!cancelled) setLoaded(true);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const day = transition?.startDate ? getDayNumber(transition.startDate) : null;
  const phase = day !== null ? phaseForDay(day) : null;
  return { loaded, transition, stakeholders, decisions, day, phase };
}
